import React from 'react';
import './PlaceHolderHome.css'; // Asegúrate de tener las clases shimmer aquí

const PlaceholderBanner = () => {
  return (
    <div className="slide-images">
      <div className="hero-content position-relative overflow-hidden">
        <div className="hero-image slide-images background-place-holder" style={{ height: '600px' }} />

        <div className="container hero-action d-flex">
          <div className="action-content col-md-6 col-xxl-8 col-xl-10 col-lg-11 text-left justify-content-center">
            <div className="placeholder-title shimmer w-75 mb-3" style={{ height: '2.5rem' }} />
            <div className="placeholder-line shimmer w-50 mb-3" style={{ height: '1.5rem' }} />
            <div className="placeholder-button shimmer w-25" style={{ height: '2.25rem' }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlaceholderBanner;